if (!$.debounce) {
    $.debounce = debounce;
}

/**
 *
 * @param {number} time int
 * @param {function} func
 * @param {object} [bindContext]
 * @returns {function}
 */
function debounce(time, func, bindContext) {
    let timeout;

    if (!Number.isInteger(time) || time < 0) {
        throw new Error('time is not a positive integer');
    }

    if (false === func instanceof Function) {
        throw new Error('func is not a function');
    }

    return function debounced(...args) {
        const currentContext = this;

        clearTimeout(timeout);

        timeout = setTimeout(function timeout() {
            func.apply(bindContext || currentContext, args);
        }, time)
    }
}



// WEBPACK FOOTER //
// ./js/main/plugin/debounce.js